import { chakra } from '@chakra-ui/system';
import type { HTMLChakraProps } from '@chakra-ui/system';
import type { PropsWithChildren } from 'react';

import { useContainerStyles } from './';

export type ContainerFooterProps = PropsWithChildren<unknown> &
  HTMLChakraProps<'div'>;

export const ContainerFooter = ({
  children,
  ...props
}: ContainerFooterProps) => {
  const styles = useContainerStyles();

  return (
    <chakra.div __css={styles.containerFooter} {...props}>
      {children}
    </chakra.div>
  );
};
ContainerFooter.displayName = 'ContainerFooter';
